import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContentfulContextualHelp, ContentfulContextualHelpItem, DialogData } from '@clux-models';
import { Observable } from 'rxjs';
import { PlayVideosComponent } from '../play-videos/play-videos.component';
import { MatButton } from '@angular/material/button';
@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton],
})
export class MoreInfoComponent {
  private dialogRef = inject<MatDialogRef<MoreInfoComponent>>(MatDialogRef);
  private dialog = inject(MatDialog);
  public data = inject<DialogData<ContentfulContextualHelp>>(MAT_DIALOG_DATA);

  public contentful$: Observable<ContentfulContextualHelp>;

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public openVideo(item: ContentfulContextualHelpItem): void {
    this.dialog.open(PlayVideosComponent, {
      disableClose: true,
      data: {
        url: this.getVideoUrl(item),
        title: this.getVideoTitle(item),
      },
    });
  }

  public getUserGuideUrl(item: ContentfulContextualHelpItem): string {
    return item?.clientDocumentation?.fields?.document?.fields?.file?.url;
  }

  private getVideoUrl(item: ContentfulContextualHelpItem): string {
    return item?.clientTutorialVideo?.fields?.videos?.fields?.file?.url;
  }

  private getVideoTitle(item: ContentfulContextualHelpItem): string {
    return item?.clientTutorialVideo?.fields?.title;
  }
}
